import React from 'react';
import PropTypes, { func } from 'prop-types';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { connect } from 'react-redux';

import style from './Pagination.module.scss';

const calculateTotalPage = (sizePerPage, dataSize) => Math.ceil(dataSize / sizePerPage);

const calculatePages = (totalPages, lastPage, paginationProps) => {
  const {
    page,
    paginationSize,
    pageStartIndex,
  } = paginationProps;

  const pages = [];
  let endPage = totalPages;
  if (endPage <= 0) return [];

  let startPage = Math.max(page - Math.floor(paginationSize / 2), pageStartIndex);
  endPage = startPage + paginationSize - 1;

  if (endPage > lastPage) {
    endPage = lastPage;
    startPage = endPage - paginationSize + 1;
  }

  for (let i = startPage; i <= endPage; i += 1) {
    if (i >= pageStartIndex) pages.push(i);
  }

  return pages;
};

class Pagination extends React.Component {
  constructor() {
    super();
    this.state = {
      items: [],
      totalPages: 0,
    };
  }

  componentDidMount() {
    this.buildPageNumbers(this.props);
  }

  componentWillReceiveProps = (nextProps) => {
    this.buildPageNumbers(nextProps);
  }

  handleNextPage = ({
    page,
    onPageChange,
  }, totalPages) => () => {
    if (page < totalPages) {
      const { dispatch, dispatchType } = this.props;
      dispatch({ type: dispatchType, page: page + 1 });
      onPageChange(page + 1);
    }
  }

  handlePrevPage = ({
    page,
    onPageChange,
  }) => () => {
    if (page > 1) {
      const { dispatch, dispatchType } = this.props;
      dispatch({ type: dispatchType, page: page - 1 });
      onPageChange(page - 1);
    }
  }

  handlePageChange = ({ onPageChange }, newPage) => () => {
    const { dispatch, dispatchType } = this.props;
    dispatch({ type: dispatchType, page: newPage });
    onPageChange(newPage);
  };

  buildPageNumbers = (props) => {
    const { paginationProps } = props;
    const {
      totalSize,
      sizePerPage,
      page: currPage,
    } = paginationProps;

    const totalPages = calculateTotalPage(sizePerPage, totalSize);
    const fromTo = calculatePages(totalPages, totalPages, paginationProps);

    const items = [];
    for (let i = 0; i <= fromTo.length - 1; i += 1) {
      if (fromTo[i] === currPage) {
        items.push(
          <button key={i} type="button" className={style.selectedPaginationButton} onClick={this.handlePageChange(paginationProps, fromTo[i])}>
            {`Page ${fromTo[i]} / ${totalPages}`}
          </button>,
        );
      } else {
        items.push(
          <button key={i} type="button" className={style.paginationButton} onClick={this.handlePageChange(paginationProps, fromTo[i])}>
            {fromTo[i]}
          </button>,
        );
      }
    }

    this.setState({
      items,
      totalPages,
    });
  }

  render() {
    const { items, totalPages } = this.state;
    const { paginationProps } = this.props;

    return (
      totalPages > 1 ? (
        <div>
          <button type="button" className={style.paginationTextButton} onClick={this.handlePageChange(paginationProps, 1)}>
            <span>
              First
            </span>
          </button>
          <button type="button" className={style.paginationButton} onClick={this.handlePrevPage(paginationProps)}>
            <FaAngleLeft />
          </button>
          {items}
          <button type="button" className={style.paginationButton} onClick={this.handleNextPage(paginationProps, totalPages)}>
            <FaAngleRight />
          </button>
          <button type="button" className={style.paginationTextButton} onClick={this.handlePageChange(paginationProps, totalPages)}>
            <span>
              Last
            </span>
          </button>
        </div>
      ) : null
    );
  }
}

export default connect()(Pagination);

Pagination.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  paginationProps: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  dispatchType: PropTypes.string,
  customDispatch: func,
};

Pagination.defaultProps = {
  dispatchType: null,
};
